import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { REGEX } from 'src/app/models/Constants';
import { columnsModel } from 'src/app/models/customer.model';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { AlightTableComponent } from '../common/alight-table/alight-table.component';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}
@Component({
  selector: 'app-simulation-manager',
  templateUrl: './simulation-manager.component.html',
  styleUrls: ['./simulation-manager.component.scss']
})
export class SimulationManagerComponent implements OnInit {
  customerSearchForm: FormGroup = new FormGroup({});
  similationTypes = [{ id: 1, fieldValueDescription: 'Unknown - Inbound Call' }]
  public dataSource: any = new MatTableDataSource();
  totalRecords!: number;
  public Columns: columnsModel[] = [
    { field: 'lastName', header: 'Last Name', width: 24 },
    { field: 'firstName', header: 'First Name', width: 24 },
    { field: 'address', header: 'Address', width: 40 },
    { field: 'dateOfBirth', header: 'Date of Birth', width: 10 },
    { field: 'nationalId', header: 'National ID', width: 10 },
    { field: 'employeeId', header: 'Emp ID', width: 10 },
    { field: 'postalCode', header: 'Postal Code', width: 10 },
  ];
  constructor(public fb: FormBuilder,
    public rootService: RootScopeService,
    public customerService: CustBusService,) {
    this.createCustomerSearchForm(this.rootService.customerSearchForm.value);
  }

  ngOnInit(): void {
  }
  createCustomerSearchForm(data) {

    let dateOfBirth = this.rootService.dateFormatter(
      data['dateOfBirth'],
      'MM/dd/YYYY'
    );

    this.customerSearchForm = this.fb.group({
      clientId: new FormControl("", Validators.required),
      similationType: new FormControl(),
      lastName: new FormControl(data['lastName'], [
        Validators.required,
        Validators.pattern(REGEX.character),
      ]),
      firstName: new FormControl(data['firstName']),
      dateOfBirth: new FormControl(dateOfBirth, [
        Validators.pattern(REGEX.date),
      ]),
      nationalId: new FormControl(data['nationalId'], [
        Validators.minLength(4),
        Validators.pattern(REGEX.nospace),
      ]),
      employeeId: new FormControl(data['employeeId']),
      postalCode: new FormControl(data['postalCode']),
    });
  }
  /* istanbul ignore next */
  onClientDropDownChange(data) {

  }
  onFocus(event) {
    
  }

    /* istanbul ignore next */
  rowSelection(data) {
  }
   /*Clear all Based on live call and off call*/
  /* istanbul ignore next */
  public clearAll() {
  
  }
}
